import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";

import { SliceKeys, tablePaginationInitialValue } from "@sso/constant";
import { RootState } from "@sso/store";
import { SearchColumn } from "@sso/types";
import { getTableSortColumn, queryBuilder } from "@sso/utils";

export const UserSlice = createSlice({
  name: SliceKeys.USER,
  initialState: { pagination: tablePaginationInitialValue },
  reducers: {
    setUserPageSize: (state, action: PayloadAction<number>) => {
      state.pagination.pageIndex = tablePaginationInitialValue.pageIndex;
      state.pagination.pageSize = action.payload;
    },
    setUserPageIndex: (state, action: PayloadAction<number>) => {
      state.pagination.pageIndex = action.payload;
    },
    setUserSearchColumn: (state, action: PayloadAction<SearchColumn>) => {
      state.pagination.pageIndex = tablePaginationInitialValue.pageIndex;
      state.pagination.search[action.payload.column] = action.payload;
    },
    clearUserSearchColumn: (state, action: PayloadAction<string>) => {
      const { [action.payload]: deleteItem, ...otherSearchItems } = state.pagination.search;
      state.pagination.search = otherSearchItems;
    },
    setUserSortColumn: (state, action: PayloadAction<string>) => {
      const { column, type } = state.pagination.sort;
      state.pagination.sort = getTableSortColumn(column, action.payload, type);
      state.pagination.pageIndex = tablePaginationInitialValue.pageIndex;
    },
  },
});

export const { setUserPageSize, setUserPageIndex, setUserSortColumn, setUserSearchColumn, clearUserSearchColumn } =
  UserSlice.actions;

export const selectUserPagination = createSelector(
  (state: RootState) => state.user.pagination,
  ({ pageSize, totalPages, pageIndex, sort, search }) => ({
    pageSize: { action: setUserPageSize, value: pageSize },
    pagination: {
      totalPages,
      pageIndex,
      action: setUserPageIndex,
    },
    sort,
    search: { object: search, onChange: setUserSearchColumn, onClear: clearUserSearchColumn },
  }),
);
export const selectUserQuery = createSelector(
  (state: RootState) => state.user.pagination,
  ({ pageSize, pageIndex, search, sort }) => queryBuilder(pageSize, pageIndex, search, sort),
);

export default UserSlice.reducer;
